export const pxToRem = (value: number): string => `${value / 16}rem`
